import React from 'react'
import Page from 'layouts/Page'
import PageWrapper from '../../../PageWrapper'
import { ApplicationListContainer } from '../components/ApplicationListContainer'
import { ApplicationQueueUsRestrictedGate } from '../components/ApplicationQueueUsRestrictedGate'
import BreadcrumbNav from '../../../components/Breadcrumbs'

interface ApplicationQueueListProps {
  routeParams: {
    assignee: string
  }
}

export const ApplicationQueueList = (props: ApplicationQueueListProps) => {
  const assignee = props.routeParams.assignee
  return (
    <PageWrapper>
      <Page
        title={`${assignee}'s Application Queue`}
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Application Queues', path: '/application-queue' },
              { title: `${assignee}'s Application Queue` },
            ]}
          />
        }
      >
        <ApplicationQueueUsRestrictedGate>
          <ApplicationListContainer assignee={assignee} />
        </ApplicationQueueUsRestrictedGate>
      </Page>
    </PageWrapper>
  )
}
